module.exports = __webpack_public_path__ + "8ef22d39c812817da28438555b243555.pdf";